import { render, staticRenderFns } from "./examevalidacao.vue?vue&type=template&id=2aaf8885&scoped=true"
import script from "./examevalidacao.vue?vue&type=script&lang=js"
export * from "./examevalidacao.vue?vue&type=script&lang=js"
import style0 from "./examevalidacao.vue?vue&type=style&index=0&id=2aaf8885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf8885",
  null
  
)

export default component.exports